import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { updateHeatMap } from "./HeatMapAPI";
import { AppContext } from "../../Context";
import "./HeatMap.css";
import _, { map } from "lodash";
// import {level_arr} from '../../Essentials/variables';
import { getLevel } from '../../Essentials/common_fn';
import { BaseURL, LAST_UPDATED,level_arr } from "../../Essentials/variables";
import HeatMapIcon from "../../assets/heatmap.png";
let Token = localStorage.getItem("token");
export default function HeatMap() {
  const {
    stateData,
    setStateData,
    loader,
    setLoader,
    dealersData,
    setDealersData,
    Dealerresult,
    setDealerresult,
  } = useContext(AppContext);
  const [isActive, setActive] = useState(false);
  const optionElement = useRef();
  const [option, setOption] = useState({});
  const [count, setCount] = useState({ 1: 0, 2: 0, 3: 0, 4: 0 });
  const [salesCount, setSalesCount] = useState();
  const [coverageType, setCoverageType] = useState("Yearly");
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [showExtraLegends, setshowExtraLegends] = useState(false);
  var Rest_url="";
  const [isDealer, setisDealer] = useState(0);
  const [lig1, setlig1] = useState(
    "Covered in any prev year but not this year"
  );
  const [lig2, setlig2] = useState("Covered in this Year only");
  const [lig3, setlig3] = useState(
    "Covered any previous year and also this year"
  );
  const [lig4, setlig4] = useState("Never covered in any Year");
  const [year, setYear] = useState(parseInt((new Date().getMonth() + 1 >=4 )? new Date().getFullYear().toString() + 1:new Date().getFullYear().toString()));  /////
  const [month, setMonth] = useState("allmonth");
  const [potentialAccess, setPotentialAccess] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState("Nil");
  // const [startYear,setStartYear]=useState(2017);
  // const [startYearMonth,setstartYearMonth]=useState(2021);

  const currentYear = new Date().getFullYear();
  const currentMonthNumber = new Date().getMonth() + 1;


  let startYear = 2017;
  let startYearMonth = 2021;
  let startDealerYear= 2018;
  const userDealerEmployee = JSON.parse(localStorage.getItem("userInfo"));
  console.log("Type: ", userDealerEmployee?.type);
    if (userDealerEmployee?.level == "Dealer") {
       startYear = 2018;
       startYearMonth = 2018;
      //  setYear(0);
    }
 
  const financialYears = [];
  const financialYearsMonths = [];
  const financialYearDealer = [];

  for (let year = startYear; year <= currentYear; year++) {
    const nextYear = year + 1;
    const financialYear = `${year}-${nextYear.toString().substring(2, 4)}`;
    if(year<currentYear){
     financialYears.push(financialYear);
    }
    else if(year==currentYear && currentMonthNumber>=4)
    {
      financialYears.push(financialYear);
    } 

  }
  for (let year = startYearMonth; year <= currentYear; year++) {
    const nextYear = year + 1;
    const financialYear = `${year}-${nextYear.toString().substring(2, 4)}`;
    if(year<currentYear){
      financialYearsMonths.push(financialYear);
     }
     else if(year==currentYear && currentMonthNumber>=4)
     {
      financialYearsMonths.push(financialYear);
     } 
    // financialYearsMonths.push(financialYear);
  }
  for (let year = startDealerYear; year <= currentYear; year++) {
    const nextYear = year + 1;
    const financialYear = `${year}-${nextYear.toString().substring(2, 4)}`;
    if(year<currentYear){
      financialYearDealer.push(financialYear);
     }
     else if(year==currentYear && currentMonthNumber>=4)
     {
      financialYearDealer.push(financialYear);
     } 
    // financialYearDealer.push(financialYear);
  }

  useMemo(() => {
    if (!_.isUndefined(option.dataset)) {
      setOption({ ...option, dataset: "Nil" });
      optionElement.current.selectedIndex = 0;
    }
  }, [stateData.selected]);

  useEffect(() => {
    // console.log("Potential : ",userInfo?.potential);
    setPotentialAccess(userInfo?.potential === "Yes" ? true : false);
    console.log("show onces", potentialAccess);
    // console.log("Option Element debug",optionElement);
  }, []);
  useEffect(()=>{
    let area="";
    setSalesCount("Loading...");
    var level = getLevel(stateData.selected);
    for (var i = 0; i <= _.indexOf(level_arr, level); i++) {
      area = area + '/' + _.replace(stateData.selected[level_arr[i]], / /g, '');
    }
    Rest_url=BaseURL + "salescount/"+year+"/"+month+"/"+dealersData+area;

    axios({
      method: "GET",
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Frame-Options": "DENY",
        "Content-Security-Policy": "frame-ancestors 'none'",
        "Feature-Policy": "frame-ancestors 'none'",
      },
      withCredentials: false,
      url:Rest_url
    }).then((res) => {
       console.log("nikhil2",res?.data?.count);
       setSalesCount(res?.data?.count);
    });

    console.log("nikhil1",Rest_url);
  },[option.dataset, year, month, dealersData])

     

  useEffect(() => {
    
    if (coverageType === "Yearly") {
      setlig1(`Covered in any previous year but not this year`);
      setlig2(`Covered in this Year only`);
      setlig3(`Covered in any previous year and also this year`);
      setlig4("Never covered in any Year");
      setshowExtraLegends(true);
    } else if (coverageType == "Monthly") {
      setlig1(
        `Covered in previous month but not this month in this Financial Year`
      );
      setlig2(`Covered in this Month only in this Financial Year`);
      setlig3(
        `Covered in any previous Month and also this Month in this Financial Year`
      );
      setlig4("Never covered in this Financial Year");
      setshowExtraLegends(false);
    }
    const userData = JSON.parse(localStorage.getItem("userInfo"));
    if (userData?.level == "Dealer") {
      setDealersData(userData?.type);
     
      console.log(userData?.type);
    }
    console.log(userData.type);

    if (!_.isUndefined(option.dataset)) {
      dealersData === "employee" ? setisDealer(0) : setisDealer(1);
      // setisDealer(0);

      updateHeatMap(
        option.dataset,
        stateData.selected,
        stateData,
        setStateData,
        loader,
        setLoader,
        setCount,
        year,
        month,
        dealersData
      );

      if (_.isEmpty(stateData.selected.Sub_District)) {
        setOption({ ...option, dataset: "Nil" });
        optionElement.current.selectedIndex = 0;
      }
    }
  }, [option.dataset, stateData.selected, year, month, dealersData]);

  useEffect(() => {
    optionElement.current.selectedIndex = 0;///added
    setSelectedDataset("Nil");// added
    setDealersData("employee");
    if (stateData.selected.State != "" && stateData.selected.District !== "" && stateData.selected.Sub_District !== "") {
      axios({
        method: "GET",
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Frame-Options": "DENY",
          "Content-Security-Policy": "frame-ancestors 'none'",
          "Feature-Policy": "frame-ancestors 'none'",
        },
        withCredentials: false,
        url: BaseURL + "getdealers/state/" + stateData.selected.State, // +'/'+stateData.selected.District+'/'+stateData.selected.Sub_District
      }).then((res) => {
        setDealerresult(res.data);
        // Dealerresult=res.data;
        //  console.log(Dealerresult);
      });
      console.log("Call API here");
    }
    // console.log(stateData.selected);
  }, [stateData.selected]);

  const legendsObj = {
    Coverage: [
      { id: 1, color: "rgb(210, 34, 45, 0.5)", content: `${lig1}` },
      { id: 2, color: "rgb(255, 191, 0, 0.5)", content: `${lig2}` },
      { id: 3, color: "rgb(35, 136, 35, 0.5)", content: `${lig3}` },
      { id: 4, color: "rgb(0,0,0,0.5)", content: `${lig4}` },
    ],
    potential: [
      {
        id: 1,
        color: "rgb(35, 136, 35, 0.5)",
        content: "High Potential (Uncovered Village)",
      },
      {
        id: 2,
        color: "rgb(255, 191, 0, 0.5)",
        content: "Medium Potential (Uncovered Village)",
      },
      {
        id: 3,
        color: "rgb(210, 34, 45, 0.5)",
        content: "Low Potential (Uncovered Village)",
      },
      { id: 4, color: "rgb(173, 216, 230,0.5)", content: "Covered Villages" },
    ],
    Dealer: [
      { id: 1, color: "rgb(210, 34, 45, 0.5)", content: `${lig1}` },
      { id: 2, color: "rgb(255, 191, 0, 0.5)", content: `${lig2}` },
      { id: 3, color: "rgb(35, 136, 35, 0.5)", content: `${lig3}` },
      { id: 4, color: "rgb(0,0,0,0.5)", content: `${lig4}` },
      // {
      //   id: 5,
      //   color: "rgb(128,0,128,0.5)",
      //   content: "Covered By Other Dealers",
      // },
    ],
  };
  function getLegend(name) {
    if (!_.isEmpty(name) && !_.isUndefined(name) && name !== "Nil") {
      if (!isDealer) {
        return legendsObj[name].map((o) => {
          return (
            <li>
              <span
                className="dot"
                style={{ backgroundColor: o["color"] }}
              ></span>
              <span style={{ fontSize: "10px" }}>
                {o.content}:[{count[o.id]}]
              </span>
            </li>
          );
        });
      } else {
        return legendsObj["Dealer"].map((o) => {
          return (
            <li>
              <span
                className="dot"
                style={{ backgroundColor: o["color"] }}
              ></span>
              <span style={{ fontSize: "10px" }}>
                {o.content}:[{count[o.id]}]
              </span>
            </li>
          );
        });
      }
    }
  }
  return (
    <div>
      <div
        className={isActive ? "heatMap-btn active" : "heatMap-btn"}
        onClick={() => {
          setActive(!isActive);
        }}
      >
        <img src={HeatMapIcon} alt="Heat Map Icon" />
        HEAT MAP
      </div>
      <div
        className={
          isActive ? "heatMap-container" : "heatMap-container inActive"
        }
      >
        <div className="heatmap-heading-div">
          <h5 className="heatmap-header">INSIGHTS</h5>
        </div>

        <form ref={optionElement} className="header-form">
          <div className="dataset-select-div">
            <select
              onChange={(v) => {
                setOption({ ...option, dataset: v.target.value });
                setSelectedDataset(v.target.value);
              }}
              id="countries"
              className="datasetSelect"
              value={selectedDataset} // new added
            >
              <option key="Nil" value="Nil">
                Select Dataset...
              </option>
              <option
                key="Coverage"
                value="Coverage"
                disabled={_.isEmpty(stateData?.selected.Sub_District)}
              >
                {" "}
                Coverage
              </option>
              {/* <option key="potential" value="potential" disabled={_.isEmpty(stateData.selected.Sub_District)}>Potential</option> */}
              <option
                key="potential"
                value="potential"
                disabled={
                  _.isEmpty(stateData?.selected.Sub_District) ||
                  !potentialAccess
                }
              >
                Potential
              </option>
            </select>
          </div>
          {option.dataset === "Coverage" && (
            <div className="dataset-select-div">
              <select
                onChange={(e) => {
                  setCoverageType(e.target.value);
                  if (
                    e.target.value === "Yearly" ||
                    e.target.value === "default"
                  ) {
                    setMonth("allmonth");
                  }
                }}
                id="countries"
                className="datasetSelect"
              >
                <option key="default" value="default">
                  Coverage Type
                </option>
                <option key="Monthly" value="Monthly">
                  Monthly Coverage
                </option>
                <option key="Yearly" value="Yearly">
                  Yearly Coverage
                </option>
              </select>
            </div>
          )}
          {/* {option.dataset==='Coverage' && <div className="mb-2">
                 <select onChange={(e)=>{ setDealersData(e.target.value) }}  id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5 py-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                   <option key="employee" value="employee">Employee</option>
                   {Dealerresult.map((res) => (
                     <option key={res.dealer_cd} value={res.dealer_cd}>
                       {`${res.dealer_name}`}
                     </option>
                   ))}
                   
                 </select>
              </div>} */}
          {option.dataset === "Coverage" && coverageType === "Yearly" && (
            <div className="dataset-select-div">
              <select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="countries"
                className="datasetSelect"
              >
                <option key="default" value="default">
                  select year
                </option>
                {userDealerEmployee?.type === "employee" && !isDealer && (
                  <option key="2017" value="2017">
                    FY 2014-17
                  </option>
                )}
                {financialYears.map((year) => (
                  <option
                    key={parseInt(year.substring(0, year.length - 3)) + 1}
                    value={parseInt(year.substring(0, year.length - 3)) + 1}
                  >
                    {`FY ${year}`}
                  </option>
                ))}
              </select>
            </div>
          )}

          {option.dataset === "Coverage" && coverageType === "Monthly" && (
            <div className="dataset-select-div">
              <select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="countries"
                className="datasetSelect"
              >
                <option key="default" value="default">
                  select year
                </option>
                {!isDealer &&
                  financialYearsMonths.map((year) => (
                    <option
                      key={parseInt(year.substring(0, year.length - 3)) + 1}
                      value={parseInt(year.substring(0, year.length - 3)) + 1}
                    >
                      {`FY ${year}`}
                    </option>
                  ))}
                {isDealer &&
                  financialYearDealer.map((year) => (
                    <option
                      key={parseInt(year.substring(0, year.length - 3)) + 1}
                      value={parseInt(year.substring(0, year.length - 3)) + 1}
                    >
                      {`FY ${year}`}
                    </option>
                  ))}
              </select>
            </div>
          )}
          {option.dataset === "Coverage" &&
            coverageType === "Monthly" &&
            year >= 2021 && (
              <div className="dataset-select-div">
                {/* <select onChange={(e)=>{ setMonth(e.target.value) }}  id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5 py-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"> */}
                <select
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  id="countries"
                  className="datasetSelect"
                >
                  <option key="Se" value="allmonth">
                    Select Month
                  </option>
                  <option key="pr" value="4">
                    April
                  </option>
                  <option key="ay" value="5">
                    May
                  </option>
                  <option key="June" value="6">
                    June
                  </option>
                  <option key="July" value="7">
                    July
                  </option>
                  <option key="ug" value="8">
                    August
                  </option>
                  <option key="ep" value="9">
                    September
                  </option>
                  <option key="ct" value="10">
                    October
                  </option>
                  <option key="ov" value="11">
                    November
                  </option>
                  <option key="ec" value="12">
                    December
                  </option>
                  <option key="an" value="1">
                    January
                  </option>
                  <option key="eb" value="2">
                    February
                  </option>
                  <option key="ar" value="3">
                    March
                  </option>
                </select>
              </div>
            )}
          {/* <div className="flex items-center justify-between">
           
          </div> */}
        </form>
        <br></br>

        {option.dataset === "Coverage" && <div
          className={
            !_.isEmpty(option.dataset) && option.dataset !== "Nil"
              ? "legend mb-2"
              : "legend close"
          }
        >
          <hr />
          {<p className="pt-2">SALES COUNT : {salesCount || 0}</p>}
        </div>}

        <div
          className={
            !_.isEmpty(option.dataset) && option.dataset !== "Nil"
              ? "legend"
              : "legend close"
          }
        >
          <hr />
          {/* <h6 className="legend-heading label">Legend</h6> */}
          <ul className="legend-options">{getLegend(option.dataset)}</ul>
        </div>
        <div
          className={
            (_.isEmpty(option.dataset) || option.dataset === "Nil") &&
            !stateData.selected.Sub_District
              ? "heatmap-message"
              : "heatmap-message close"
          }
        >
          <h6>HeatMap will work after selection of SubDistrict</h6>
        </div>
      </div>
    </div>
  );
}
